module.exports = __webpack_public_path__ + "static/media/more_games_en.8915353c.png";